import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { P as PHONE_MASKS, S as SSN_MASK } from './form-input-masks.js';
import { u as updateFormValues, a as updateAddressFormValues, b as updateDateOfBirthFormValues } from './input-handlers.js';
import { d as defineCustomElement$7 } from './custom-popper2.js';
import { d as defineCustomElement$6 } from './form-control-date2.js';
import { d as defineCustomElement$5 } from './form-control-number-masked2.js';
import { d as defineCustomElement$4 } from './form-control-select2.js';
import { d as defineCustomElement$3 } from './form-control-text2.js';
import { d as defineCustomElement$2 } from './form-control-tooltip2.js';
import { d as defineCustomElement$1 } from './identity-address-form.js';

const BusinessOwnerFormInputs = /*@__PURE__*/ proxyCustomElement(class BusinessOwnerFormInputs extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.inputHandler = (name, value) => {
            updateFormValues(this.formController, { [name]: value });
        };
        this.onAddressFormUpdate = (values) => {
            updateAddressFormValues(this.formController, Object.assign(Object.assign({}, this.formController.values.getValue().address), values));
        };
    }
    render() {
        return (h("div", { key: '97911ef690cb7932c0e382cfa79fa3333536055c', class: "row gy-3" }, h("div", { key: '0f15a832bcde62a50fb791e008dcd7da68c8da6b', class: "col-12 col-md-8" }, h("form-control-text", { key: 'fdc50a224e7e17d2923d6eb1fb274103e0d55710', name: "name", label: "Full Name", defaultValue: this.ownerDefaultValue.name, errorText: this.errors.name, inputHandler: this.inputHandler })), h("div", { key: 'c4be24670525f2b90fd6de5a0035241190dadd09', class: "col-12 col-md-4" }, h("form-control-text", { key: '8752eb6ea1d24189fd1a4d799145b5bbdc0413f2', name: "title", label: "Title", defaultValue: this.ownerDefaultValue.title, errorText: this.errors.title, inputHandler: this.inputHandler, helpText: "Role at your business, e.g. President, CEO, Treasurer." })), h("div", { key: '9d19f00bbd407ca55455947d84183530920d799c', class: "col-12 col-md-6" }, h("form-control-text", { key: '10ffe5b44086f623fb9f9d27f4a72cd251589bd0', name: "email", label: "Email Address", defaultValue: this.ownerDefaultValue.email, errorText: this.errors.email, inputHandler: this.inputHandler })), h("div", { key: '7c32fc26abbc0bc16b0a50d8bbfb47c121c7c62d', class: "col-12 col-md-6" }, h("form-control-number-masked", { key: 'e6b63872de5bd5cc98d61c8e6ebeb2a3f8443fb1', name: "phone", label: "Phone Number", defaultValue: this.ownerDefaultValue.phone, errorText: this.errors.phone, inputHandler: this.inputHandler, mask: PHONE_MASKS.US })), h("div", { key: '2e7eded46b1162d9ecf8c3badc869e98a710abee', class: "col-12 col-md-4" }, h("form-control-date", { key: '2c4b8c126d7505dadb3fe06b3b5cab5e83b91c23', name: "dob_full", label: "Birth Date", defaultValue: this.ownerDefaultValue.dob_full, errorText: this.errors.dob_full, inputHandler: this.inputHandler, onFormControlInput: (e) => updateDateOfBirthFormValues(e, this.formController), helpText: "Must be 18 or older." })), h("div", { key: 'dd96fdddddfb082fc0ce670f673decc97956c242', class: "col-12 col-md-8" }, h("form-control-number-masked", { key: '640cc2e749dc64879d8211c3340b7c273d3cb817', name: "identification_number", label: "SSN", defaultValue: this.ownerDefaultValue.identification_number, errorText: this.errors.identification_number, inputHandler: this.inputHandler, mask: SSN_MASK, helpText: "Enter your full Social Security Number. It is required for Federal OFAC check." })), h("div", { key: '681b2898183d73559150b5debef39901c4679eba', class: "col-12" }, h("justifi-identity-address-form", { key: 'e2de39be536c0854592a5132a6a9ac9d761a0f9b', errors: this.errors.address, defaultValues: this.ownerDefaultValue.address, handleFormUpdate: this.onAddressFormUpdate }))));
    }
    ;
}, [0, "owner-form-inputs", {
        "ownerDefaultValue": [8, "owner-default-value"],
        "errors": [8],
        "formController": [16, "form-controller"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["owner-form-inputs", "custom-popper", "form-control-date", "form-control-number-masked", "form-control-select", "form-control-text", "form-control-tooltip", "justifi-identity-address-form"];
    components.forEach(tagName => { switch (tagName) {
        case "owner-form-inputs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BusinessOwnerFormInputs);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "form-control-date":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "form-control-number-masked":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BusinessOwnerFormInputs as B, defineCustomElement as d };
